// 'use client';

// import { useState, useEffect } from 'react';
// import ProductCard from './ProductCard';
// import ComparisonMatrix from './ComparisonMatrix';
// import FilterPanel from './FilterPanel';
// import ArchitectureDiagram from './ArchitectureDiagram';
// import Icon from '@/components/ui/AppIcon';

// interface ProductFeature {
//   name: string;
//   description: string;
// }

// interface ProductSpec {
//   label: string;
//   value: string;
// }

// interface Product {
//   id: string;
//   name: string;
//   tagline: string;
//   description: string;
//   image: string;
//   alt: string;
//   category: string;
//   features: ProductFeature[];
//   specs: ProductSpec[];
//   integrations: string[];
//   complexity: 'Low' | 'Medium' | 'High';
//   documentation: string;
//   apiEndpoint: string;
// }

// const mockProducts: Product[] = [
//   {
//     id: 'uss-mdm',
//     name: 'USS MDM',
//     tagline: 'Secure Device Management at Scale',
//     description:
//       'Enterprise-grade Mobile Device Management platform designed to centrally manage, secure, and monitor devices across global teams with minimal operational overhead.',
//     image: 'https://img.rocket.new/generatedImages/rocket_gen_img_mdm.png',
//     alt: 'Clean dashboard showing managed mobile and desktop devices',
//     category: 'Device Management',
//     features: [
//       {
//         name: 'Centralized Device Control',
//         description: 'Manage all enrolled devices from a single, unified console',
//       },
//       {
//         name: 'Policy Enforcement',
//         description: 'Apply security, access, and compliance policies in real time',
//       },
//       {
//         name: 'Remote Actions',
//         description: 'Lock, wipe, or reset devices instantly from anywhere',
//       },
//       {
//         name: 'Compliance Monitoring',
//         description: 'Track device health and compliance status continuously',
//       },
//     ],
//     specs: [
//       { label: 'Supported Devices', value: 'Android, iOS, Windows' },
//       { label: 'Policy Sync', value: 'Real-time' },
//       { label: 'Encryption', value: 'AES-256' },
//       { label: 'Deployment', value: 'Cloud-based' },
//     ],
//     integrations: ['Google Workspace', 'Microsoft Entra ID', 'Apple Business Manager'],
//     complexity: 'Medium',
//     documentation: 'https://docs.uss.example/mdm',
//     apiEndpoint: '/api/v1/mdm',
//   },
//   {
//     id: 'uss-video-sdk',
//     name: 'USS Video SDK',
//     tagline: 'Real-Time Video, Built In',
//     description:
//       'Developer-friendly video SDK for embedding secure, low-latency video communication directly into web and mobile applications with global reliability.',
//     image: 'https://img.rocket.new/generatedImages/rocket_gen_img_video.png',
//     alt: 'Minimal video call interface with multiple participants',
//     category: 'Video Infrastructure',
//     features: [
//       {
//         name: 'Real-Time Video & Audio',
//         description: 'Low-latency video streaming optimized for global networks',
//       },
//       {
//         name: 'Scalable Sessions',
//         description: 'Support 1:1 calls or multi-participant rooms with ease',
//       },
//       { name: 'Secure by Default', description: 'End-to-end encrypted media transport' },
//       {
//         name: 'Easy SDK Integration',
//         description: 'Simple APIs and clear documentation for fast adoption',
//       },
//     ],
//     specs: [
//       { label: 'Latency (Avg)', value: '<200ms' },
//       { label: 'Max Participants', value: '100+' },
//       { label: 'Encryption', value: 'DTLS-SRTP' },
//       { label: 'Platforms', value: 'Web, Android, iOS' },
//     ],
//     integrations: ['WebRTC', 'React', 'Android SDK', 'iOS SDK'],
//     complexity: 'Low',
//     documentation: 'https://docs.uss.example/video-sdk',
//     apiEndpoint: '/api/v1/video',
//   },
// ];

// export default function ProductsInteractive() {
//   const [isHydrated, setIsHydrated] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState('All');
//   const [selectedComplexity, setSelectedComplexity] = useState('All');
//   const [comparedProducts, setComparedProducts] = useState<string[]>([]);
//   const [showComparison, setShowComparison] = useState(false);
//   const [showArchitecture, setShowArchitecture] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');

//   useEffect(() => {
//     setIsHydrated(true);
//   }, []);

//   if (!isHydrated) {
//     return (
//       <div className="min-h-screen bg-background pt-[72px]">
//         <div className="w-full px-6 lg:px-8 py-12">
//           <div className="max-w-7xl mx-auto">
//             <div className="h-32 bg-muted rounded animate-pulse mb-8" />
//             <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
//               <div className="lg:col-span-1">
//                 <div className="h-96 bg-muted rounded animate-pulse" />
//               </div>
//               <div className="lg:col-span-3">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   {[1, 2, 3, 4].map((i) => (
//                     <div key={i} className="h-96 bg-muted rounded animate-pulse" />
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   const categories = ['All', ...Array.from(new Set(mockProducts.map((p) => p.category)))];
//   const complexities = ['All', 'Low', 'Medium', 'High'];

//   const filteredProducts = mockProducts.filter((product) => {
//     const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;
//     const matchesComplexity =
//       selectedComplexity === 'All' || product.complexity === selectedComplexity;
//     const matchesSearch =
//       searchQuery === '' ||
//       product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       product.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       product.tagline.toLowerCase().includes(searchQuery.toLowerCase());
//     return matchesCategory && matchesComplexity && matchesSearch;
//   });

//   const handleCompareToggle = (productId: string) => {
//     setComparedProducts((prev) => {
//       if (prev.includes(productId)) {
//         return prev.filter((id) => id !== productId);
//       }
//       if (prev.length >= 4) {
//         return prev;
//       }
//       return [...prev, productId];
//     });
//   };

//   const handleResetFilters = () => {
//     setSelectedCategory('All');
//     setSelectedComplexity('All');
//     setSearchQuery('');
//   };

//   return (
//     <div className="min-h-screen bg-background pt-[72px]">
//       <div className="w-full px-6 lg:px-8 py-12">
//         <div className="max-w-7xl mx-auto">
//           {/* Hero Section */}
//           <div className="mb-12">
//             <div className="flex items-center space-x-2 mb-4">
//               <Icon name="CubeIcon" size={32} className="text-accent" />
//               <h1 className="text-4xl lg:text-5xl font-heading font-bold text-foreground">
//                 Product Ecosystem
//               </h1>
//             </div>
//             <p className="text-lg text-muted-foreground max-w-3xl">
//               Explore our comprehensive suite of enterprise-grade products designed for global
//               infrastructure. Each product is built with technical excellence, security, and
//               scalability at its core.
//             </p>
//           </div>

//           {/* Search and Actions Bar */}
//           <div className="mb-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
//             <div className="relative flex-1 max-w-md">
//               <Icon
//                 name="MagnifyingGlassIcon"
//                 size={20}
//                 className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
//               />
//               <input
//                 type="text"
//                 placeholder="Search products..."
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 className="w-full pl-10 pr-4 py-3 bg-card border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-accent"
//               />
//             </div>
//             <div className="flex items-center space-x-3">
//               <button
//                 onClick={() => setShowArchitecture(true)}
//                 className="flex items-center space-x-2 px-4 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors duration-300"
//               >
//                 <Icon name="ChartBarIcon" size={20} />
//                 <span className="text-sm font-medium">View Architecture</span>
//               </button>
//               {comparedProducts.length > 0 && (
//                 <button
//                   onClick={() => setShowComparison(true)}
//                   className="flex items-center space-x-2 px-4 py-3 bg-accent text-accent-foreground rounded-lg hover:bg-accent/90 transition-colors duration-300"
//                 >
//                   <Icon name="ScaleIcon" size={20} />
//                   <span className="text-sm font-medium">Compare ({comparedProducts.length})</span>
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Main Content Grid */}
//           <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
//             {/* Filter Panel */}
//             <div className="lg:col-span-1">
//               <FilterPanel
//                 categories={categories}
//                 complexities={complexities}
//                 selectedCategory={selectedCategory}
//                 selectedComplexity={selectedComplexity}
//                 onCategoryChange={setSelectedCategory}
//                 onComplexityChange={setSelectedComplexity}
//                 onReset={handleResetFilters}
//               />
//             </div>

//             {/* Products Grid */}
//             <div className="lg:col-span-3">
//               {filteredProducts.length === 0 ? (
//                 <div className="bg-card rounded-xl border border-border p-12 text-center">
//                   <Icon
//                     name="FolderOpenIcon"
//                     size={48}
//                     className="text-muted-foreground mx-auto mb-4"
//                   />
//                   <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
//                     No Products Found
//                   </h3>
//                   <p className="text-sm text-muted-foreground mb-4">
//                     Try adjusting your filters or search query to find what you're looking for.
//                   </p>
//                   <button
//                     onClick={handleResetFilters}
//                     className="px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors duration-300"
//                   >
//                     Reset Filters
//                   </button>
//                 </div>
//               ) : (
//                 <>
//                   <div className="mb-4 flex items-center justify-between">
//                     <p className="text-sm text-muted-foreground">
//                       Showing {filteredProducts.length} of {mockProducts.length} products
//                     </p>
//                     {comparedProducts.length > 0 && (
//                       <button
//                         onClick={() => setComparedProducts([])}
//                         className="text-sm text-accent hover:text-accent/80 font-medium transition-colors duration-300"
//                       >
//                         Clear Selection
//                       </button>
//                     )}
//                   </div>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     {filteredProducts.map((product) => (
//                       <ProductCard
//                         key={product.id}
//                         product={product}
//                         onCompare={handleCompareToggle}
//                         isComparing={comparedProducts.includes(product.id)}
//                       />
//                     ))}
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           {/* Info Banner */}
//           <div className="mt-12 bg-accent/10 border border-accent/20 rounded-xl p-6">
//             <div className="flex items-start space-x-4">
//               <Icon name="LightBulbIcon" size={24} className="text-accent flex-shrink-0 mt-1" />
//               <div>
//                 <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
//                   Need Help Choosing?
//                 </h3>
//                 <p className="text-sm text-muted-foreground mb-4">
//                   Our technical team can help you select the right products for your infrastructure
//                   needs. Schedule a consultation to discuss your requirements and get personalized
//                   recommendations.
//                 </p>
//                 <div className="flex items-center space-x-3">
//                   <a
//                     href="/pricing-plans"
//                     className="px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors duration-300 text-sm font-medium"
//                   >
//                     Schedule Demo
//                   </a>
//                   <a
//                     href="/global-support"
//                     className="px-6 py-2 bg-card text-foreground border border-border rounded-lg hover:bg-muted transition-colors duration-300 text-sm font-medium"
//                   >
//                     Contact Support
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Modals */}
//       {showComparison && (
//         <ComparisonMatrix
//           products={mockProducts}
//           selectedProducts={comparedProducts}
//           onClose={() => setShowComparison(false)}
//         />
//       )}

//       {showArchitecture && <ArchitectureDiagram onClose={() => setShowArchitecture(false)} />}
//     </div>
//   );
// }

'use client';

import { useState, useEffect, useRef } from 'react';
import ProductCard from './ProductCard';
import ComparisonMatrix from './ComparisonMatrix';
import FilterPanel from './FilterPanel';
import ArchitectureDiagram from './ArchitectureDiagram';
import Icon from '@/components/ui/AppIcon';
import { MDM_OVERVIEW_URL } from '@/lib/ssoHandoff';

interface ProductFeature {
  name: string;
  description: string;
}

interface ProductSpec {
  label: string;
  value: string;
}

interface Product {
  id: string;
  name: string;
  tagline: string;
  description: string;
  image: string;
  alt: string;
  category: string;
  features: ProductFeature[];
  specs: ProductSpec[];
  integrations: string[];
  complexity: 'Low' | 'Medium' | 'High';
  documentation: string;
  apiEndpoint: string;
  appUrl: string;
}

const mockProducts: Product[] = [
  {
    id: 'uss-mdm',
    name: 'USS MDM',
    tagline: 'Secure Device Management at Scale',
    description:
      'Enterprise-grade Mobile Device Management platform designed to centrally manage, secure, and monitor devices across global teams with minimal operational overhead.',
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_mdm.png',
    alt: 'Clean dashboard showing managed mobile and desktop devices',
    category: 'Device Management',
    // Standalone MDM app on a sibling subdomain — the USS session is handed to it
    // via the shared parent-domain cookies written in lib/ssoHandoff.ts.
    appUrl: MDM_OVERVIEW_URL,
    features: [
      {
        name: 'Centralized Device Control',
        description: 'Manage all enrolled devices from a single, unified console',
      },
      {
        name: 'Policy Enforcement',
        description: 'Apply security, access, and compliance policies in real time',
      },
      {
        name: 'Remote Actions',
        description: 'Lock, wipe, or reset devices instantly from anywhere',
      },
      {
        name: 'Compliance Monitoring',
        description: 'Track device health and compliance status continuously',
      },
    ],
    specs: [
      { label: 'Supported Devices', value: 'Android, iOS, Windows' },
      { label: 'Policy Sync', value: 'Real-time' },
      { label: 'Encryption', value: 'AES-256' },
      { label: 'Deployment', value: 'Cloud-based' },
    ],
    integrations: ['Google Workspace', 'Microsoft Entra ID', 'Apple Business Manager'],
    complexity: 'Medium',
    documentation: 'https://docs.uss.example/mdm',
    apiEndpoint: '/api/v1/mdm',
  },
  {
    id: 'uss-video-sdk',
    name: 'USS Video SDK',
    tagline: 'Real-Time Video, Built In',
    description:
      'Developer-friendly video SDK for embedding secure, low-latency video communication with live translation directly into web and mobile applications.',
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_video.png',
    alt: 'Minimal video call interface with multiple participants',
    category: 'Video Infrastructure',
    appUrl: '/apps/video-sdk',

    features: [
      {
        name: 'Real-Time Video & Audio',
        description: 'Low-latency video streaming optimized for global networks',
      },
      {
        name: 'Scalable Sessions',
        description: 'Support 1:1 calls or multi-participant rooms with ease',
      },
      { name: 'Secure by Default', description: 'End-to-end encrypted media transport' },
      {
        name: 'Easy SDK Integration',
        description: 'Simple APIs and clear documentation for fast adoption',
      },
    ],
    specs: [
      { label: 'Latency (Avg)', value: '<50ms' },
      { label: 'Max Participants', value: '100+' },
      { label: 'Encryption', value: 'DTLS-SRTP' },
      { label: 'Platforms', value: 'Web, Android, iOS' },
    ],
    integrations: ['WebRTC', 'React', 'Android SDK', 'iOS SDK'],
    complexity: 'Low',
    documentation: 'https://docs.uss.example/video-sdk',
    apiEndpoint: '/api/v1/video',
  },
];

export default function ProductsInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedComplexity, setSelectedComplexity] = useState('All');
  const [comparedProducts, setComparedProducts] = useState<string[]>([]);
  const [showComparison, setShowComparison] = useState(false);
  const [showArchitecture, setShowArchitecture] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  // Animated background particles
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const updateSize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    updateSize();
    window.addEventListener('resize', updateSize);

    const particles = Array.from({ length: 30 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 0.3,
      vy: (Math.random() - 0.5) * 0.3,
      size: Math.random() * 2 + 0.5,
    }));

    let animationId: number;
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'rgba(14, 165, 233, 0.3)';

      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;

        if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.vy *= -1;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
      });

      ctx.strokeStyle = 'rgba(14, 165, 233, 0.1)';
      ctx.lineWidth = 1;
      particles.forEach((p1, i) => {
        particles.slice(i + 1).forEach((p2) => {
          const dx = p1.x - p2.x;
          const dy = p1.y - p2.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 120) {
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
          }
        });
      });

      animationId = requestAnimationFrame(animate);
    };
    animate();

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:551:6" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="551" data-component-end-line="569" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-%5B%230B1220%5D%20pt-%5B72px%5D%22%7D" className="min-h-screen bg-[#0B1220] pt-[72px]">
        <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:552:8" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="552" data-component-end-line="568" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20px-6%20lg%3Apx-8%20py-12%22%7D" className="w-full px-6 lg:px-8 py-12">
          <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:553:10" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="553" data-component-end-line="567" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%22%7D" className="max-w-7xl mx-auto">
            <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:554:12" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="554" data-component-end-line="554" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-32%20bg-white%2F5%20rounded%20animate-pulse%20mb-8%22%7D" className="h-32 bg-white/5 rounded animate-pulse mb-8" />
            <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:555:12" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="555" data-component-end-line="566" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 lg:grid-cols-4 gap-6">
              <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:556:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="556" data-component-end-line="558" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-1%22%7D" className="lg:col-span-1">
                <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:557:16" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="557" data-component-end-line="557" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-96%20bg-white%2F5%20rounded%20animate-pulse%22%7D" className="h-96 bg-white/5 rounded animate-pulse" />
              </div>
              <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:559:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="559" data-component-end-line="565" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-3%22%7D" className="lg:col-span-3">
                <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:560:16" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="560" data-component-end-line="564" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20gap-6%22%7D" className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {[1, 2, 3, 4].map((i) => (
                    <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:562:20" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="562" data-component-end-line="562" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-96%20bg-white%2F5%20rounded%20animate-pulse%22%7D" key={i} className="h-96 bg-white/5 rounded animate-pulse" />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const categories = ['All', ...Array.from(new Set(mockProducts.map((p) => p.category)))];
  const complexities = ['All', 'Low', 'Medium', 'High'];

  const filteredProducts = mockProducts.filter((product) => {
    const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;
    const matchesComplexity =
      selectedComplexity === 'All' || product.complexity === selectedComplexity;
    const matchesSearch =
      searchQuery === '' ||
      product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.tagline.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesComplexity && matchesSearch;
  });

  const handleCompareToggle = (productId: string) => {
    setComparedProducts((prev) => {
      if (prev.includes(productId)) {
        return prev.filter((id) => id !== productId);
      }
      if (prev.length >= 4) {
        return prev;
      }
      return [...prev, productId];
    });
  };

  const handleResetFilters = () => {
    setSelectedCategory('All');
    setSelectedComplexity('All');
    setSearchQuery('');
  };

  return (
    <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:607:4" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="607" data-component-end-line="767" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-%5B%230B1220%5D%20pt-%5B72px%5D%20relative%20overflow-hidden%22%7D" className="min-h-screen bg-[#0B1220] pt-[72px] relative overflow-hidden">
      {/* Animated Canvas Background */}
      <canvas data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:609:6" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="609" data-component-end-line="612" data-component-file="ProductsInteractive.tsx" data-component-name="canvas" data-component-content="%7B%22elementName%22%3A%22canvas%22%2C%22className%22%3A%22absolute%20inset-0%20w-full%20h-full%20opacity-40%20pointer-events-none%22%7D"
        ref={canvasRef}
        className="absolute inset-0 w-full h-full opacity-40 pointer-events-none"
      />

      {/* Gradient Orbs */}
      <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:615:6" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="615" data-component-end-line="615" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-20%20left-20%20w-96%20h-96%20bg-%5B%230EA5E9%5D%2F20%20rounded-full%20blur-3xl%20animate-pulse%20pointer-events-none%22%7D" className="absolute top-20 left-20 w-96 h-96 bg-[#0EA5E9]/20 rounded-full blur-3xl animate-pulse pointer-events-none" />
      <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:616:6" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="616" data-component-end-line="619" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-20%20right-20%20w-96%20h-96%20bg-%5B%231B365D%5D%2F30%20rounded-full%20blur-3xl%20animate-pulse%20pointer-events-none%22%7D"
        className="absolute bottom-20 right-20 w-96 h-96 bg-[#1B365D]/30 rounded-full blur-3xl animate-pulse pointer-events-none"
        style={{ animationDelay: '1s' }}
      />

      <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:621:6" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="621" data-component-end-line="755" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20px-4%20sm%3Apx-6%20lg%3Apx-8%20py-8%20sm%3Apy-12%20relative%20z-10%22%7D" className="w-full px-4 sm:px-6 lg:px-8 py-8 sm:py-12 relative z-10">
        <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:622:8" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="622" data-component-end-line="754" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%22%7D" className="max-w-7xl mx-auto">
          {/* Hero Section */}
          <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:624:10" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="624" data-component-end-line="643" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-8%20sm%3Amb-12%22%7D" className="mb-8 sm:mb-12">
            <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:625:12" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="625" data-component-end-line="628" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22inline-flex%20items-center%20gap-2%20px-4%20py-2%20rounded-full%20bg-%5B%230EA5E9%5D%2F10%20border%20border-%5B%230EA5E9%5D%2F30%20backdrop-blur-sm%20mb-4%20sm%3Amb-6%22%7D" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0EA5E9]/10 border border-[#0EA5E9]/30 backdrop-blur-sm mb-4 sm:mb-6">
              <Icon data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:626:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="626" data-component-end-line="626" data-component-file="ProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22SparklesIcon%22%2C%22className%22%3A%22text-%5B%230EA5E9%5D%22%7D" name="SparklesIcon" size={16} className="text-[#0EA5E9]" />
              <span data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:627:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="627" data-component-end-line="627" data-component-file="ProductsInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-sm%20text-%5B%230EA5E9%5D%20font-medium%22%2C%22textContent%22%3A%22Product%20Ecosystem%22%7D" className="text-sm text-[#0EA5E9] font-medium">Product Ecosystem</span>
            </div>

            <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:630:12" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="630" data-component-end-line="642" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20gap-3%20sm%3Agap-4%20mb-4%20sm%3Amb-6%22%7D" className="flex items-start gap-3 sm:gap-4 mb-4 sm:mb-6">
              <Icon data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:631:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="631" data-component-end-line="631" data-component-file="ProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22CubeIcon%22%2C%22className%22%3A%22text-%5B%230EA5E9%5D%20mt-1%20hidden%20sm%3Ablock%22%7D" name="CubeIcon" size={32} className="text-[#0EA5E9] mt-1 hidden sm:block" />
              <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:632:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="632" data-component-end-line="641" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
                <h1 data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:633:16" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="633" data-component-end-line="635" data-component-file="ProductsInteractive.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22text-3xl%20sm%3Atext-4xl%20lg%3Atext-5xl%20font-bold%20bg-gradient-to-r%20from-white%20to-white%2F80%20bg-clip-text%20text-transparent%20mb-3%20sm%3Amb-4%22%2C%22textContent%22%3A%22Product%20Ecosystem%22%7D" className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent mb-3 sm:mb-4">
                  Product Ecosystem
                </h1>
                <p data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:636:16" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="636" data-component-end-line="640" data-component-file="ProductsInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-base%20sm%3Atext-lg%20text-white%2F70%20max-w-3xl%22%2C%22textContent%22%3A%22Explore%20our%20comprehensive%20suite%20of%20enterprise-grade%20products%20designed%20for%20global%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20infrastructure.%20Each%20product%20is%20built%20with%20technical%20excellence%2C%20security%2C%20and%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20scalability%20at%20its%20core.%22%7D" className="text-base sm:text-lg text-white/70 max-w-3xl">
                  Explore our comprehensive suite of enterprise-grade products designed for global
                  infrastructure. Each product is built with technical excellence, security, and
                  scalability at its core.
                </p>
              </div>
            </div>
          </div>

          {/* Search and Actions Bar */}
          <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:646:10" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="646" data-component-end-line="661" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-6%20sm%3Amb-8%20flex%20flex-col%20sm%3Aflex-row%20items-start%20sm%3Aitems-center%20justify-between%20gap-3%20sm%3Agap-4%22%7D" className="mb-6 sm:mb-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
            <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:647:12" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="647" data-component-end-line="660" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20flex-1%20w-full%20max-w-md%22%7D" className="relative flex-1 w-full max-w-md">
              <Icon data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:648:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="648" data-component-end-line="652" data-component-file="ProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22MagnifyingGlassIcon%22%2C%22className%22%3A%22absolute%20left-3%20top-1%2F2%20transform%20-translate-y-1%2F2%20text-white%2F40%20z-10%22%7D"
                name="MagnifyingGlassIcon"
                size={20}
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-white/40 z-10"
              />
              <input data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:653:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="653" data-component-end-line="659" data-component-file="ProductsInteractive.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22value%22%3A%22%5Bvar%3AsearchQuery%5D%22%2C%22className%22%3A%22w-full%20pl-10%20pr-4%20py-3%20bg-white%2F5%20border%20border-white%2F10%20rounded-xl%20text-white%20placeholder-white%2F40%20focus%3Aoutline-none%20focus%3Aring-2%20focus%3Aring-%5B%230EA5E9%5D%20focus%3Aborder-transparent%20backdrop-blur-sm%22%7D"
                type="text"
                placeholder="Search products..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] focus:border-transparent backdrop-blur-sm"
              />
            </div>
          </div>

          {/* Main Content Grid */}
          <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:664:10" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="664" data-component-end-line="722" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            {/* Filter Panel */}
            <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:666:12" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="666" data-component-end-line="676" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-1%22%7D" className="lg:col-span-1">
              <FilterPanel data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:667:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="667" data-component-end-line="675" data-component-file="ProductsInteractive.tsx" data-component-name="FilterPanel" data-component-content="%7B%22elementName%22%3A%22FilterPanel%22%7D"
                categories={categories}
                complexities={complexities}
                selectedCategory={selectedCategory}
                selectedComplexity={selectedComplexity}
                onCategoryChange={setSelectedCategory}
                onComplexityChange={setSelectedComplexity}
                onReset={handleResetFilters}
              />
            </div>

            {/* Products Grid */}
            <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:679:12" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="679" data-component-end-line="721" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-3%22%7D" className="lg:col-span-3">
              {filteredProducts.length === 0 ? (
                <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:681:16" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="681" data-component-end-line="693" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22backdrop-blur-xl%20bg-white%2F5%20rounded-2xl%20border%20border-white%2F10%20p-8%20sm%3Ap-12%20text-center%22%7D" className="backdrop-blur-xl bg-white/5 rounded-2xl border border-white/10 p-8 sm:p-12 text-center">
                  <Icon data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:682:18" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="682" data-component-end-line="682" data-component-file="ProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22FolderOpenIcon%22%2C%22className%22%3A%22text-white%2F40%20mx-auto%20mb-4%22%7D" name="FolderOpenIcon" size={48} className="text-white/40 mx-auto mb-4" />
                  <h3 data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:683:18" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="683" data-component-end-line="683" data-component-file="ProductsInteractive.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-bold%20text-white%20mb-2%22%2C%22textContent%22%3A%22No%20Products%20Found%22%7D" className="text-lg font-bold text-white mb-2">No Products Found</h3>
                  <p data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:684:18" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="684" data-component-end-line="686" data-component-file="ProductsInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-white%2F60%20mb-4%22%2C%22textContent%22%3A%22Try%20adjusting%20your%20filters%20or%20search%20query%20to%20find%20what%20you're%20looking%20for.%22%7D" className="text-sm text-white/60 mb-4">
                    Try adjusting your filters or search query to find what you're looking for.
                  </p>
                  <button data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:687:18" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="687" data-component-end-line="692" data-component-file="ProductsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-6%20py-2%20bg-gradient-to-r%20from-%5B%230EA5E9%5D%20to-%5B%231B365D%5D%20text-white%20rounded-xl%20hover%3Aopacity-90%20transition-all%20duration-300%22%2C%22textContent%22%3A%22Reset%20Filters%22%7D"
                    onClick={handleResetFilters}
                    className="px-6 py-2 bg-gradient-to-r from-[#0EA5E9] to-[#1B365D] text-white rounded-xl hover:opacity-90 transition-all duration-300"
                  >
                    Reset Filters
                  </button>
                </div>
              ) : (
                <>
                  <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:696:18" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="696" data-component-end-line="708" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-4%20flex%20items-center%20justify-between%22%7D" className="mb-4 flex items-center justify-between">
                    <p data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:697:20" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="697" data-component-end-line="699" data-component-file="ProductsInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-white%2F60%22%2C%22textContent%22%3A%22Showing%20of%20products%22%7D" className="text-sm text-white/60">
                      Showing {filteredProducts.length} of {mockProducts.length} products
                    </p>
                    {comparedProducts.length > 0 && (
                      <button data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:701:22" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="701" data-component-end-line="706" data-component-file="ProductsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22text-sm%20text-%5B%230EA5E9%5D%20hover%3Atext-%5B%230EA5E9%5D%2F80%20font-medium%20transition-colors%20duration-300%22%2C%22textContent%22%3A%22Clear%20Selection%22%7D"
                        onClick={() => setComparedProducts([])}
                        className="text-sm text-[#0EA5E9] hover:text-[#0EA5E9]/80 font-medium transition-colors duration-300"
                      >
                        Clear Selection
                      </button>
                    )}
                  </div>
                  <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:709:18" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="709" data-component-end-line="718" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20gap-4%20sm%3Agap-6%22%7D" className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                    {filteredProducts.map((product) => (
                      <ProductCard data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:711:22" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="711" data-component-end-line="716" data-component-file="ProductsInteractive.tsx" data-component-name="ProductCard" data-component-content="%7B%22elementName%22%3A%22ProductCard%22%7D"
                        key={product.id}
                        product={product}
                        onCompare={handleCompareToggle}
                        isComparing={comparedProducts.includes(product.id)}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Info Banner */}
          <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:725:10" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="725" data-component-end-line="753" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-8%20sm%3Amt-12%20backdrop-blur-xl%20bg-%5B%230EA5E9%5D%2F10%20border%20border-%5B%230EA5E9%5D%2F30%20rounded-2xl%20p-5%20sm%3Ap-6%22%7D" className="mt-8 sm:mt-12 backdrop-blur-xl bg-[#0EA5E9]/10 border border-[#0EA5E9]/30 rounded-2xl p-5 sm:p-6">
            <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:726:12" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="726" data-component-end-line="752" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20gap-3%20sm%3Agap-4%22%7D" className="flex items-start gap-3 sm:gap-4">
              <Icon data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:727:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="727" data-component-end-line="727" data-component-file="ProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22LightBulbIcon%22%2C%22className%22%3A%22text-%5B%230EA5E9%5D%20flex-shrink-0%20mt-1%22%7D" name="LightBulbIcon" size={24} className="text-[#0EA5E9] flex-shrink-0 mt-1" />
              <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:728:14" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="728" data-component-end-line="751" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%22%7D" className="flex-1">
                <h3 data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:729:16" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="729" data-component-end-line="731" data-component-file="ProductsInteractive.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-base%20sm%3Atext-lg%20font-bold%20text-white%20mb-2%22%2C%22textContent%22%3A%22Need%20Help%20Choosing%3F%22%7D" className="text-base sm:text-lg font-bold text-white mb-2">
                  Need Help Choosing?
                </h3>
                <p data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:732:16" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="732" data-component-end-line="736" data-component-file="ProductsInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-white%2F70%20mb-4%22%2C%22textContent%22%3A%22Our%20technical%20team%20can%20help%20you%20select%20the%20right%20products%20for%20your%20infrastructure%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20needs.%20Schedule%20a%20consultation%20to%20discuss%20your%20requirements%20and%20get%20personalized%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20recommendations.%22%7D" className="text-sm text-white/70 mb-4">
                  Our technical team can help you select the right products for your infrastructure
                  needs. Schedule a consultation to discuss your requirements and get personalized
                  recommendations.
                </p>
                <div data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:737:16" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="737" data-component-end-line="750" data-component-file="ProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20sm%3Aflex-row%20items-stretch%20sm%3Aitems-center%20gap-2%20sm%3Agap-3%22%7D" className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
                  <a data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:738:18" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="738" data-component-end-line="743" data-component-file="ProductsInteractive.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%2Fpricing-plans%22%2C%22className%22%3A%22px-6%20py-2.5%20bg-gradient-to-r%20from-%5B%230EA5E9%5D%20to-%5B%231B365D%5D%20text-white%20rounded-xl%20hover%3Aopacity-90%20transition-all%20duration-300%20text-sm%20font-medium%20text-center%22%2C%22textContent%22%3A%22Schedule%20Demo%22%7D"
                    href="/pricing-plans"
                    className="px-6 py-2.5 bg-gradient-to-r from-[#0EA5E9] to-[#1B365D] text-white rounded-xl hover:opacity-90 transition-all duration-300 text-sm font-medium text-center"
                  >
                    Schedule Demo
                  </a>
                  <a data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:744:18" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="744" data-component-end-line="749" data-component-file="ProductsInteractive.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%2Fglobal-support%22%2C%22className%22%3A%22px-6%20py-2.5%20bg-white%2F5%20text-white%20border%20border-white%2F20%20rounded-xl%20hover%3Abg-white%2F10%20transition-all%20duration-300%20text-sm%20font-medium%20text-center%22%2C%22textContent%22%3A%22Contact%20Support%22%7D"
                    href="/global-support"
                    className="px-6 py-2.5 bg-white/5 text-white border border-white/20 rounded-xl hover:bg-white/10 transition-all duration-300 text-sm font-medium text-center"
                  >
                    Contact Support
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      {showComparison && (
        <ComparisonMatrix data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:759:8" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="759" data-component-end-line="763" data-component-file="ProductsInteractive.tsx" data-component-name="ComparisonMatrix" data-component-content="%7B%22elementName%22%3A%22ComparisonMatrix%22%7D"
          products={mockProducts}
          selectedProducts={comparedProducts}
          onClose={() => setShowComparison(false)}
        />
      )}

      {showArchitecture && <ArchitectureDiagram data-component-id="src/app/(public)/products-overview/components/ProductsInteractive.tsx:766:27" data-component-path="src/app/(public)/products-overview/components/ProductsInteractive.tsx" data-component-line="766" data-component-end-line="766" data-component-file="ProductsInteractive.tsx" data-component-name="ArchitectureDiagram" data-component-content="%7B%22elementName%22%3A%22ArchitectureDiagram%22%7D" onClose={() => setShowArchitecture(false)} />}
    </div>
  );
}
